import bu from './module/bu'
import TASKAPI from './module/task'
import TMSAPI from './module/tms'

// 统一注册API
const API = { 
  ...bu,
  ...TASKAPI,
  ...TMSAPI
 }

export default API
